import { useQuery } from '@tanstack/react-query';
import { getBatteryModels } from '../api/client';
import { Card, CardContent, CardHeader, CardTitle } from '@connectdevice/ui';

export function BatteryModelsPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['battery-models'],
    queryFn: getBatteryModels,
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Battery Models</h2>
        <p className="text-sm text-gray-500 mt-1">
          Configure battery model thresholds for test evaluation
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {isLoading && <p className="text-gray-400">Loading...</p>}
        {isError && <p className="text-red-500">Failed to load battery models.</p>}

        {data?.data.map((model) => (
          <Card key={model.id}>
            <CardHeader>
              <CardTitle>{model.name}</CardTitle>
            </CardHeader>
            <CardContent>
              <dl className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <dt className="text-gray-500">Voltage</dt>
                  <dd className="font-medium">{model.voltage}V</dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-gray-500">Capacity</dt>
                  <dd className="font-medium">{model.capacityMah} mAh</dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-gray-500">Approval threshold</dt>
                  <dd className="font-medium text-green-600">{model.approvalThreshold}%</dd>
                </div>
                <div className="flex justify-between">
                  <dt className="text-gray-500">Rejection threshold</dt>
                  <dd className="font-medium text-red-600">{model.rejectionThreshold}%</dd>
                </div>
                {model.description && (
                  <div>
                    <dt className="text-gray-500">Description</dt>
                    <dd className="text-gray-700 mt-1">{model.description}</dd>
                  </div>
                )}
              </dl>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
